package or.garden.manager.domain.model

import kotlinx.serialization.Serializable
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@Serializable
data class PlantingResponse(
    val month: String,
    val data: List<PlantingItem>? = null,
)


@Serializable
data class PlantingItem @OptIn(ExperimentalUuidApi::class) constructor(
    val id: String = Uuid.random().toString(),
    val vegetableType: String,
    val sowingDate: String,
    val varietySelection: String? = null,
    val recommendedSeedlingCount: String? = null,
    val directPlanting: Boolean = false,
    val month: Int = 1
)

